import { Modal, Row, Col, Form } from 'react-bootstrap'
import {useState, useEffect, useContext} from 'react'
import CurrencyInput from '../../formElements/CurrencyInput'
import {FormInput} from '../../formElements/FormInput'
import {validateFormFields} from '../../../utils'
import AuthorizationService from '../../../services/AuthorizationMaintenanceService'
import IssueAuthorizationService from '../../../services/IssueAuthorizationService'
import { IssuerContext, UserContext } from '../../../UserContext'
import AddAuthorizationRef from './addAuthorizationRef'
import CommonService from '../../../services/CommonService'
import { toast } from 'react-toastify'

const AddIssuanceAuthorization = (props) => {
    const loginUser = useContext(UserContext);
    const issuerId = useContext(IssuerContext);
    const {onModalClose, finalSaleId} = props;
    const [formErrors,setFormErrors] = useState({});
    const [authorizationNames, setAuthorizationNames] = useState([]);
    const [addNewAuthorization, setAddNewAuthorization] = useState(false);
    const [authorizationInfo, setAuthorizationInfo] = useState({
        'authorizationName': '',
        'authorityReducedAmount': '',
        'originalAuthorizedAmt': '',
        'replenishedAuthAmount': '',
        'authorizationDate': '',
        'netChange': '',
        'outstandingAmt': ''
    })

    const getAuthorizationRefLookups = () => {
        var obj = {
            "msgId": null,
            "sysId": null,
            "opr": "getAuthorizationRefLookupsByIssuerId",
            "hdrStruct": null,
            "queryParam": null,
            "reqData": {"id": issuerId}
        };
    
        AuthorizationService.getAuthorizationsByIssuerId(obj)
          .then((res) => res)
          .then((result) => {
            setAuthorizationNames(result.data.responses[0]);
        });
    }
    useEffect(() => {
        getAuthorizationRefLookups();
        // eslint-disable-next-line
    }, []);

    const getAuthorizationRef = (authorizationId, authArray) => {
        var obj = {
            "msgId": null,
            "sysId": null,
            "opr": "getAuthorizationRef",
            "hdrStruct": null,
            "queryParam": null,
            "reqData": {"authorizationId": authorizationId}
        };
    
        IssueAuthorizationService.getAuthorizationRef(obj)
          .then((res) => res)
          .then((result) => {
            if(result.data.errors && result.data.errors.length > 0){
                toast.error(result.data.errors[0].message)
            } else {
                setAuthorizationInfo({...authArray, 
                    'originalAuthorizedAmt': result.data.responses[0].authorizationAmt,
                    'authorizationDate': result.data.responses[0].electionDate
                });
            }
        });
    }
    const handleAuthChange = (e) => {
        const {name, value} = e.target;
        let authArray = {...authorizationInfo};
        authArray[name] = value;
        if(name === 'authorizationName'){
            const outstandingAmount = authorizationNames.filter(el => el.authorizationId === parseInt(value))[0].outstandingAmount;
            authArray['outstandingAmt'] = outstandingAmount;
            getAuthorizationRef(parseInt(value), authArray);
        }
        if(name==="authorityReducedAmount" || name === "replenishedAuthAmount") {
            const replenishedAuthAmount = authArray['replenishedAuthAmount'] ? parseFloat(authArray['replenishedAuthAmount'].replace(/,/g, '')) : 0;
            const authorityReducedAmount = authArray['authorityReducedAmount'] ? parseFloat(authArray['authorityReducedAmount'].replace(/,/g, '')) : 0;
            let netChangeTotal = (replenishedAuthAmount*10 - authorityReducedAmount*10)/10;
            netChangeTotal = String(netChangeTotal).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            authArray['netChange'] = netChangeTotal;
        }

        setAuthorizationInfo(authArray);
    }

    const handleAddNewAuthorization = () => {
        setAddNewAuthorization(true);
    }

    const handleAddNewAuthClose = () => {
        setAddNewAuthorization(false);
        getAuthorizationRefLookups();
    }
  
    const createAuthorization = (issueAuthorization) => {

        let obj = {
            "msgId": null,
            "sysId": null,
            "opr": "postIssueAuthorization",
            "hdrStruct": null,
            "queryParam": null,
            "reqData": {
                "issueAuthorization": {
                    "authorizationId": issueAuthorization.authorizationName,
                    "finalSaleId": finalSaleId,
                    "proposeDebtId": null,
                    "originalAuthorizedAmt": issueAuthorization.originalAuthorizedAmt,
                    "authorizationDate": issueAuthorization.authorizationDate,
                    "authorityReplenishAmt": issueAuthorization.replenishedAuthAmount,
                    "authorityReducedAmt": issueAuthorization.authorityReducedAmount,
                    "createDatetime": new Date(),
                    "createUser": loginUser,
                    "lastUpdateDatetime": new Date(),
                    "lastUpdateUser": loginUser
                }
            }
        };
        
        IssueAuthorizationService.addAuthorization(obj)
        .then((res) => res)
        .then((result) => {
        });
    }

    const handleSubmit = (e) => {
        const form = e.target.closest('form#add-form');
        let formErrors = validateFormFields(form.elements);
        if(Object.keys(formErrors).length > 0) {
            setFormErrors(formErrors);
        } else {
            setFormErrors({});
            createAuthorization(authorizationInfo);
            onModalClose();
        }
    }
    return (
        <div style={{ position: 'relative', zIndex: '1' }} >
        <Modal show={true} onHide={onModalClose} backdrop="static" >
            
            {addNewAuthorization ?
                <><Modal.Header closeButton><h3>Add New Authorization</h3></Modal.Header>
                <Modal.Body><AddAuthorizationRef onModalClose={handleAddNewAuthClose} /></Modal.Body></> : 
                <><Modal.Header closeButton><h3>Add Issuance Authorization</h3></Modal.Header>
                <Modal.Body>
                <form id="add-form">
                    <Row>
                        <Col md={12}>
                            <div className="control">
                                <label><span className="required">*</span>Authorization Name</label>
                                <Form.Select name="authorizationName" 
                                    onChange={(e)=>handleAuthChange(e)} 
                                    data-validations="required"
                                    value={authorizationInfo.authorizationName}
                                    // style={formErrors['authorizationName'] && {border: `solid 1px red`}}
                                >
                                    <option value="">select</option>
                                    {authorizationNames.length !== 0 && authorizationNames.map((auth, i) => {
                                        return <option key={`authname_${i}`} value={auth.authorizationId}>{auth.authorizationLookupName}</option>
                                    })}
                                </Form.Select>
                                { formErrors && formErrors['authorizationName'] && <p className="error">{ formErrors['authorizationName'] }</p>}
                            </div>
                            <button type="button" className="link-button" onClick={()=>handleAddNewAuthorization()} id="add_new"><small>Add New Authorization</small></button>
                        </Col>
                        <Col md={6}>
                            <div className="control">
                                <FormInput 
                                label="Current Remaining Authorization" 
                                name="outstandingAmt" 
                                value={authorizationInfo.outstandingAmt} 
                                helpText="Outstanding Amount"
                                disabled="disabled"/>
                            </div>
                        </Col>
                        </Row>
                        <Row>
                        
                        <Col md={6}>
                            <div className="control">
                            <FormInput 
                                label="Original Authorized Amount" 
                                name="originalAuthorizedAmt" 
                                value={authorizationInfo.originalAuthorizedAmt !== "" ? CommonService.currencyFormatter(authorizationInfo.originalAuthorizedAmt) : ''} 
                                helpText="The original maximum amount of debt authorized by the vote of the electorate or action of the governing body."
                                disabled="disabled"/>
                            </div>
                        </Col>
                         
                        <Col md={6}>
                            <div className="control"><span className="required">*</span>
                                <CurrencyInput 
                                    label="Amount Authority Reduced (By this Issue)" 
                                    name="authorityReducedAmount" 
                                    defaultValue={authorizationInfo.authorityReducedAmt} 
                                    onBlur={(e)=>handleAuthChange(e)}
                                    helpText="Amount Authority Reduced (By this Issue)"
                                    validations={["required"]}
                                    error ={ formErrors && formErrors['authorityReducedAmount'] }/>
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="control">
                            <FormInput 
                                label="Authorization Date: (MM/DD/YYYY)" 
                                name="originalAuthorizionDate" 
                                value={authorizationInfo.authorizationDate !== '' ? CommonService.dateFormatter(authorizationInfo.authorizationDate) : ''} 
                                helpText="Authorization Date"
                                disabled="disabled"/>
                            </div>
                        </Col>    
                        <Col md={6}>
                            <div className="control">
                                <span className="required">*</span>
                                <CurrencyInput
                                label="Amount Authority Replenished (By this Issue)" 
                                name="replenishedAuthAmount" 
                                defaultValue={authorizationInfo.authorityReplenishAmt} 
                                onBlur={(e)=>handleAuthChange(e)}
                                validations={["required"]}
                                error={formErrors && formErrors['replenishedAuthAmount']}
                                helpText="Amount Authority Replenished(By this Issue)"/>
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="control">
                                <FormInput type="text" label="Net Change (By this Issue)" 
                                name="netChange" 
                                value={authorizationInfo.netChange}
                                readOnly="true"
                                disabled="disabled" 
                                helpText="Net Change"/>
                            </div>
                        </Col>                    
                    </Row>

                    <div className="btn-div">
                    <div className="fright">
                    <button type="button" className="custom-button-secondary  btn-secondary" onClick={()=>onModalClose()}>Cancel</button>{" "}
                    <button type="button" className="custom-button" onClick={(e)=>handleSubmit(e)}>Save</button>
                    </div>
                </div>
                </form>
                </Modal.Body></>
            }
            
           
        </Modal>
        </div>
    )
}

export default AddIssuanceAuthorization
